import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=1bd10065&scoped=true&"
import script from "./Reports.ts?vue&type=script&lang=ts&"
export * from "./Reports.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd10065",
  null
  
)

export default component.exports
import {QSelect,QInput,QItem,QItemSection,QPopupProxy,QDate,QIcon,QBtn,QSpinnerGears,QDialog,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign({QSelect,QInput,QItem,QItemSection,QPopupProxy,QDate,QIcon,QBtn,QSpinnerGears,QDialog,QCard,QCardSection}, component.options.components || {})
